// extracted by mini-css-extract-plugin
export default {"item":"ListingItemCarousel-item","image":"ListingItemCarousel-image"};